var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import shallowEqual from 'shallowequal';
import { findDOMNode } from 'react-dom';
import scrollIntoView from 'scroll-into-view-if-needed';
import cs from '../_util/classNames';
import Tooltip from '../Tooltip';
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.scrollIntoView = function () {
            var _a = _this.props, selectedKeys = _a.selectedKeys, _key = _a._key, autoScrollIntoView = _a.autoScrollIntoView, scrollConfig = _a.scrollConfig;
            if (autoScrollIntoView && ~selectedKeys.indexOf(_key)) {
                var defaultConfig = {
                    behavior: 'smooth',
                    block: 'top',
                    // scrollMode: 'if-needed',
                    boundary: document.body,
                };
                scrollIntoView(findDOMNode(_this), __assign(__assign({}, defaultConfig), scrollConfig));
            }
        };
        _this.isSelected = function () {
            var _a = _this.props, selectedKeys = _a.selectedKeys, _key = _a._key;
            return selectedKeys && !selectedKeys.indexOf(_key);
        };
        _this.clickItem = function (e) {
            var _a = _this.props, _key = _a._key, onClickMenuItem = _a.onClickMenuItem, triggerItemClick = _a.triggerItemClick, disabled = _a.disabled, onClick = _a.onClick;
            if (disabled) {
                return;
            }
            onClickMenuItem && onClickMenuItem(_key);
            triggerItemClick && triggerItemClick();
            onClick && onClick(e);
        };
        return _this;
    }
    Item.prototype.componentDidMount = function () {
        this.scrollIntoView();
    };
    Item.prototype.componentDidUpdate = function (prevProps) {
        if (!shallowEqual(prevProps.selectedKeys, this.props.selectedKeys)) {
            this.scrollIntoView();
        }
    };
    Item.prototype.render = function () {
        var _a = this.props, children = _a.children, prefixCls = _a.prefixCls, level = _a.level, mode = _a.mode, disabled = _a.disabled, collapse = _a.collapse, className = _a.className, style = _a.style, activeItemBorderDirection = _a.activeItemBorderDirection;
        var classNames = cs(prefixCls + "-item", {
            selected: this.isSelected(),
            disabled: disabled,
        }, className);
        var paddingStyle = {
            paddingLeft: (level - 1) * 24,
            display: 'block',
        };
        var borderDirection = 'left';
        if (activeItemBorderDirection === 'right') {
            borderDirection = 'right';
        }
        var selectedBorderClassName = "selected-border-" + borderDirection;
        var itemText = function () {
            if (mode === 'pop' || collapse) {
                if (level === 1 && collapse) {
                    return (React.createElement("span", null,
                        React.createElement("div", { className: selectedBorderClassName }),
                        children));
                }
                if (level !== 1) {
                    // 是triger里的内容，不需要icon
                    return children;
                }
            }
            if (mode === 'horizontal' && level !== 1) {
                return children;
            }
            return (React.createElement("span", { style: __assign({}, paddingStyle) },
                mode !== 'horizontal' && React.createElement("div", { className: selectedBorderClassName }),
                children));
        };
        if (level === 1 && collapse) {
            return (React.createElement(Tooltip, { trigger: "hover", content: React.createElement("span", null, children), position: "right", triggerProps: { className: prefixCls + "-item-tooltip" } },
                React.createElement("div", { style: style, className: classNames, onClick: this.clickItem }, itemText())));
        }
        return (React.createElement("div", { className: classNames, onClick: this.clickItem, style: style }, itemText()));
    };
    Item.propTypes = {
        _key: PropTypes.string,
        level: PropTypes.number,
    };
    Item.menuType = 'MenuItem';
    return Item;
}(PureComponent));
export default Item;
